import { IdleQueue } from "idlize/IdleQueue.mjs";
import loadScript from "load-script2";
import mobile from "is-mobile";
import autopilot from "modules/third-party-scripts/auto-pilot";

const queue = new IdleQueue();



  const jQueryUrl = "/public_site_assets/jquery-3.4.1-e200ee796ef24add7054280d843a80de75392557bb4248241e870fac0914c0c1.js";
  queue.pushTask(
    () => {
      loadScript(jQueryUrl).then(
        () => {
          queue.pushTask(() => {
            autopilot("76ea8a812dc24bc697238faeb94ce8ffc19ba7986fda4ec69f44cf9f17d09dea", "Y4ku6hSjbRhdKCCtcmFuZ2VtZTI");
          });
        },
        () => {
          Sentry.captureMessage("jQuery did not load from the CDN", { fingerprint: ["{{ default }}", "jQueryLoadFailed"] });
        }
      )
    }
  )

